import { Routes } from '@angular/router';
import { FileTokenService } from './api';

export const PROPERTY_WIZARD_ROUTES: Routes = [
  {
    path: '',
    providers: [FileTokenService],
    loadComponent: () => import('./property-wizard.component').then(m => m.PropertyWizardComponent),
  },
];
